/**
 * Application configuration
 * Centralized configuration management using environment variables
 */

// Detect if we're running on the production domain (same-origin API via nginx /api/)
const isProductionHost = typeof window !== 'undefined' &&
  (window.location.hostname === 'likaships.com' ||
    window.location.hostname === 'www.likaships.com' ||
    window.location.hostname.endsWith('.likaships.com'));

function withApiSuffix(url) {
  const raw = String(url || '').replace(/\/$/, '');
  return /\/api$/i.test(raw) ? raw : `${raw}/api`;
}

const config = {
  // API Configuration
  api: {
    // Host only in env (e.g. https://likaships.com); /api is appended for requests
    baseURL: withApiSuffix(
      isProductionHost
        ? window.location.origin
        : (import.meta.env.VITE_API_URL || 'http://localhost:5000')
    ),
    timeout: 30000, // 30 seconds
  },

  // Environment
  env: {
    isDevelopment: import.meta.env.DEV,
    isProduction: import.meta.env.PROD,
    mode: import.meta.env.MODE || 'development',
  },

  // App Configuration
  app: {
    name: import.meta.env.VITE_APP_NAME || 'Likaperfumes',
    version: import.meta.env.VITE_APP_VERSION || '1.0.0',
  },

  // Feature flags (optional)
  features: {
    enableAnalytics: import.meta.env.VITE_ENABLE_ANALYTICS === 'true',
    enableDebugMode: import.meta.env.VITE_DEBUG_MODE === 'true',
  }
}

// Log configuration in development or when on remote server
if (config.env.isDevelopment || isProductionHost) {
  console.log('🔧 App Configuration:', {
    api: config.api.baseURL,
    environment: config.env.mode,
    isProductionHost: isProductionHost,
    hostname: typeof window !== 'undefined' ? window.location.hostname : 'N/A',
    app: config.app.name,
    version: config.app.version,
  })
}

export default config
